import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { SovosIconButton } from "mosaic-react";
import { Download } from "mosaic-react-icons";

export default function DownloadFile(props) {
    const { i18n, downloadFile, pushNotification, params } = useGlobalValue();
    const { value: cell } = props || {};
    const { id, name, entity } = cell;
    return (
        <SovosIconButton
            tooltipText={i18n`Download File`}
            children={<Download />}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                downloadFile({
                    fileName: name,
                    importId: id,
                    id: `tooltip_${id}`,
                    entity,
                    projectId: params?.projectId,
                }).catch(() => {
                    pushNotification({
                        open: true,
                        message: i18n`Something went wrong!`,
                        type: "error",
                        timeout: "short",
                    });
                });
            }}
        />
    );
}
